import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { StorageService } from "../../services/storage.service";

import { TraceIdHelper } from "./../../../assets/js/commons/trace-id.helper";

/**
 * Servicio para generar la recarga de tiempo aire
 */
@Injectable()
export class CreatePaymentOrderService {
  /**
   * url del servicios
   */
  private url;

  /**
   * Valida el ambiente donde se ejecuta la app y arma la url necesaria
   * @param http
   * @param storageService
   */
  constructor(
    private http: HttpClient,
    private storageService: StorageService
  ) {
    if (this.storageService.get("ENV") == "localhost") {
      this.url = this.storageService.get("HOST") + "/billtae/createtae";
    } else {
      this.url =
        this.storageService.get("HOST") +
        this.storageService.get("SOURCE") +
        "/billtae/createtae";
    }
  }

  /***
   * Lanza la peticion en metodo post
   */
  recargarTAE(data: any): Observable<any> {
    let url = this.url;
    /**
     * Descomentar para pruebas
     */
    // return this.http.get('../../assets/json/recargar.json');
    /**
     * Descomentar para ambientes
     */
    const isTransmit = localStorage.getItem("isTransmit");
    const traceId = this.storageService.get("traceId");

    let headers = {};
    if (isTransmit?.toString() === "true") {
      url += "/transmit";
      const token = localStorage.getItem("token2fa");
      const codeVerifier = localStorage.getItem("codeVerifier");
      headers = {
        "x-authentication-Method": "jwt",
        "x-authentication-Value": `${codeVerifier}|${token.replace(/"/g, "")}`,
        "x-spanId": traceId?.toString(),
        "x-traceId": traceId?.toString(),
      };
    }
    return this.http.post(url, data, { headers });
  }
}
